/**
 *  Admin Site Product Listing Page
 */
import React, { Component } from 'react';
import { Row, Col,Container } from 'reactstrap';
import AdminproductList from '../../widgets/AdminProduct';
import Pagination from '../../services/Pagination';
import "react-toastify/dist/ReactToastify.min.css";
import { ToastContainer, toast } from "react-toastify";
import Loading from "../../shared/components/Loading/Loading";
import firebase from "firebase";
import requestApi from "../../apirest";
import Switch from "react-switch";

class AdminProduct extends Component {

    constructor(props) {
        super(props);
        this.state={
            productsearch:'',
            productList:[],
            currentProduct: [],
            currentPage: null,
            totalPages: null,
            cp_productList:[],
            IsDeleteProcess:false,
            loading:false,
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.findProductList();
    }



    findProductList = async () => {
        let { productList , cp_productList, currentProduct} = this.state;
        this.setState({ loading: true })

        try {
            let resp = await requestApi(`/products`, { }, "get");
            toast.success("As informações foram carregadas com sucesso.", {
                autoClose: 4000,
            });
            productList = resp.data.doc;
            cp_productList = resp.data.doc;
            currentProduct= resp.data.doc;
            this.setState({ loading: false , productList, cp_productList, currentProduct })
        } catch (error) {
            toast.error("Aconteceu algum erro inesperado.", {
            autoClose: 4000,
            });
            this.setState({ loading: false })
        }

    };

    onProductSearch(searchproduct)
    {
        if(searchproduct === '')
        {
            var curr_products = this.state.cp_productList.slice((this.state.currentPage - 1) * 12, ((this.state.currentPage - 1) * 12) + 12);
            this.setState({
                ...this.state,
                 productsearch:searchproduct,
                 productList:this.state.cp_productList,
                 currentProduct:this.state.cp_productList,
                 totalRecords:this.state.cp_productList.length,
                 IsDeleteProcess:true,
            })
            this.state.currentProduct = curr_products;
            this.forceUpdate();
            this.render();

        }
        else
        {
           let serachdata=this.state.cp_productList.filter((productname)=>{
                if(searchproduct === searchproduct.toLowerCase())
                {
                    let product=productname.name.toLowerCase().indexOf(searchproduct.toLowerCase()) > -1
                    return(
                        product
                    )
                }
                else
                {
                    let product=productname.name.toUpperCase().indexOf(searchproduct.toUpperCase()) > -1
                    return(
                        product
                    )
                }

            })
           var curr_products = null;
            if(serachdata.length > 12)
            {
                curr_products= serachdata.slice(0,12);
            }
            else {
                 curr_products= serachdata;
            }

            this.setState({
                ...this.state,
                 productsearch:searchproduct,
                 productList:serachdata,
                 currentProduct:curr_products,
                 totalRecords:searchproduct.length,
                 IsDeleteProcess:false
            })
            this.state.currentProduct = curr_products;
            this.forceUpdate();
            this.render();
        }
    }

    onPageChanged = data => {
        const { productList } = this.state;
        const { currentPage, totalPages, pageLimit } = data;

        const offset = (currentPage - 1) * pageLimit;
        const currentProduct = productList.slice(offset, offset + pageLimit);
        this.setState({
                ...this.state,
                currentPage:currentPage,
                currentProduct:currentProduct,
                totalPages:totalPages
        });
      };

      deletedProduct = async (productdata) => {
        this.setState({ loading: true })
        try {

            const data = await requestApi(`/products`, { idProduct : productdata._id }, "delete" );

            toast.success("O produto foi deletado com sucesso.", {
                autoClose: 4000,
            });
            this.setState({ loading: false })
        } catch (error) {
            toast.error("Aconteceu algum erro inesperado.", {
            autoClose: 4000,
            });
            this.setState({ loading: false })
        }
    };

     onDeleteProduct = async (productdata) => {
        if(productdata)
        {
            await this.deletedProduct(productdata);
            let deletedproduct=productdata;
            let newproduct=this.state.productList.filter((CurrentProductList)=>CurrentProductList.id !== deletedproduct.id);
            let curr_products=newproduct.filter((CurrentProductList)=>CurrentProductList.id !== deletedproduct.id);
            curr_products = curr_products.slice((this.state.currentPage - 1) * 12, ((this.state.currentPage - 1) * 12) + 12);
            let tpg = newproduct.length/12;

            this.setState({
                ...this.state,
                productList:newproduct,
                currentProduct: curr_products,
                totalRecords:newproduct.length,
                totalPages:tpg,
                IsDeleteProcess:true
            })
        }
    }

    render() {
        const {loading} = this.state;
        return (
            <div>
                <div className="mt-8 mb-8">
                    <Container>
                        <Row>
                            <Col lg={12}>
                                <div className="mb-4">
                                    <h4>Lista de Produtos</h4>
                                </div>
                                <div className="mb-4">
                                    <form>
                                        <div class="form-group">
                                            <input type="text" class="form-control" placeholder="Pesquisar produto" value={this.state.productsearch} onChange={(e)=>{this.onProductSearch(e.target.value)}}></input>
                                        </div>
                                    </form>
                                </div>

                                <div className="mb-4">
                                    {this.state.currentProduct.length > 0 ?
                                        <Row className="products products-loop grid svelta-products-shortcode pgs-product-list">
                                                {this.state.currentProduct.map((product, index) =>
                                                            <AdminproductList product={product} key={index} deleteproduct={()=>this.onDeleteProduct(product)} />
                                                    )
                                                }
                                            </Row>
                                        :
                                            <Row className="products products-loop grid svelta-products-shortcode">
                                                <div className="col-sm-12 text-center section-b-space mt-5 no-found" >
                                                    <img src={require('../../assets/images/empty-search.jpg')} className="img-fluid mb-4" />
                                                    <h3>Desculpe não encontramos nenhum produto com essas palavras.   </h3>
                                                    <p>Por favor, tente novamente com outras palavras.</p>
                                                </div>
                                            </Row>
                                        }
                                </div>
                                <div className="row mt-5">
                                <div className="col-12">
                                {this.state.productList.length > 12 ?
                                        <div>
                                         <Pagination
                                            totalRecords={this.state.productList.length}
                                            pageLimit={12}
                                            onPageChanged={this.onPageChanged}
                                            IsDeleteProcess={this.state.IsDeleteProcess}
                                        />
                                        </div>
                                        :
                                        <div style={{display:'none'}}>
                                            <Pagination
                                            totalRecords={this.state.productList.length}
                                            pageLimit={12}
                                            onPageChanged={this.onPageChanged}
                                            IsDeleteProcess={this.state.IsDeleteProcess}
                                            />
                                        </div>
                                }
                                </div>
                                </div>
                            </Col>
                        </Row>

                    </Container>
                    {loading && <Loading overlay />}
                </div>
            </div>
        )
    }
}
export default AdminProduct;
